import React, { useState } from "react";

import "./Filters.css";
import ExpandIcon from "../../ExpandIcon/ExpandIcon";
import { RadioInactive } from "../../RadioButton/RadioInactive";
import { RadioActive } from "../../RadioButton/RadioActive";
import { useDispatch, useSelector } from "react-redux";
import {
  addCuisineFilterType,
  addPriceFilterType,
  addRegionFilterType,
} from "../../../redux/reducers/DeliciousFilterTypeReducer";

import data from "../../../data/data.json";

const Filters = () => {
  const state = useSelector((state) => state.deliciousFilterType);
  const dispatch = useDispatch();

  const handleCuisineSelection = (cuisine) => {
    dispatch(addCuisineFilterType(cuisine));
  };

  const handlePriceSelection = (price) => {
    dispatch(addPriceFilterType(price));
  };

  const handleRegionSelection = (region) => {
    dispatch(addRegionFilterType(region));
  };

  return (
    <div
      className="delicious100-interactive__filters_all"
      id="delicious100-interactive__filters_all_id"
    >
      <span className="delicious100-interactive__filters_title">Filter</span>
      <ExpandIcon></ExpandIcon>
      <div className="delicious100-interactive__filters_parent">
        <div className="delicious100-interactive__filters_cuisines_box">
          <span>Cuisine</span>
          <div className="delicious100-interactive__filters_cuisines">
            {["All", ...new Set(data.map((item) => item.cuisine))]?.map(
              (cuisine) => (
                <div
                  key={`${cuisine}-parent`}
                  onClick={() => handleCuisineSelection(cuisine)}
                >
                  {state.selectedCuisineFilters?.includes(cuisine) ? (
                    <RadioActive key={`${cuisine}-radio`}></RadioActive>
                  ) : (
                    <RadioInactive key={`${cuisine}-radio`}></RadioInactive>
                  )}
                  <span key={cuisine}>{cuisine}</span>
                </div>
              )
            )}
          </div>
        </div>
        <div className="delicious100-interactive__filters_region_box">
          <span>Region</span>
          <div className="delicious100-interactive__filters_region">
            {[
              "All",
              ...[...new Set(data.flatMap((item) => item.region))].filter(
                Boolean
              ),
            ].map((region) => (
              <div
                key={`${region}-parent`}
                onClick={() => handleRegionSelection(region)}
              >
                {state.selectedRegionFilters?.includes(region) ? (
                  <RadioActive key={`${region}-radio`}></RadioActive>
                ) : (
                  <RadioInactive key={`${region}-radio`}></RadioInactive>
                )}
                <span key={region}>{region}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Filters;
